import * as Toggle from '@radix-ui/react-toggle-group'
import React, { FC } from 'react'
import styled from 'styled-components'

const SeverityContainer = styled(Toggle.Root)`
  display: flex;
  flex-wrap: wrap;
  border-radius: 4px;
  border: 1px solid rgba(255, 255, 255, 0.3);
  overflow: hidden;
  justify-items: center;
  width: fit-content;
  background-color: rgb(60, 60, 60);
`

const getSeverityColor = (severity: string): string => {
  switch (severity) {
    case '1':
      return 'rgb(209, 209, 205)'
    case '2':
      return 'rgb(223, 214, 98)'
    case '3':
      return 'rgb(223, 174, 2)'
    case '4':
      return 'rgb(219, 109, 0)'
    case '5':
      return 'rgb(179, 0, 0)'
    default:
      return 'rgb(80, 80, 80)'
  }
}

const StyledSeverityOption = styled(Toggle.Item)<{
  $selected: boolean
  $severity: string
}>`
  all: unset;
  cursor: ${({ $selected }) => ($selected ? 'auto' : 'pointer')} !important;
  background-color: ${({ theme, $selected, $severity }) =>
    $selected
      ? getSeverityColor($severity)
      : theme.forecast.background2} !important;
  opacity: 0.8 !important;
  height: 30px !important;
  min-width: 36px !important;
  padding: 0 12px !important;
  box-sizing: border-box !important;
  white-space: nowrap !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  color: ${({ $selected }) => ($selected ? '#000' : '#fff')} !important;
  font-weight: ${({ $selected }) => ($selected ? '600' : '400')} !important;

  &:hover {
    opacity: ${({ $selected }) => ($selected ? 0.8 : 1)} !important;
    background-color: ${({ theme, $selected, $severity }) =>
      $selected
        ? getSeverityColor($severity)
        : theme.forecast.background3} !important;
  }
`

const SeverityOptionButton: FC<{
  value: string
  currentSeverity: string
}> = ({ value, currentSeverity }) => {
  return (
    <StyledSeverityOption
      value={value}
      $selected={value === currentSeverity}
      $severity={value}>
      {value}
    </StyledSeverityOption>
  )
}

export const SeverityPicker: FC<{
  possibleValues: string[]
  setSeverity: (s: string) => void
  currentSeverity: string
  disabled?: boolean
}> = ({ possibleValues, setSeverity, currentSeverity, disabled }) => {
  return (
    <SeverityContainer
      type='single'
      value={currentSeverity}
      aria-label='Select severity'
      onClick={(event) => event.stopPropagation()}
      disabled={!!disabled}
      onValueChange={(value) => {
        // Check for undefined to prevent deselecting all options
        if (value) setSeverity(value)
      }}>
      {possibleValues.map((value) => (
        <SeverityOptionButton
          key={value}
          value={value}
          currentSeverity={currentSeverity}
        />
      ))}
    </SeverityContainer>
  )
}
